package kz.dentalcrm.app.screens.patients

import kotlinx.collections.immutable.toPersistentList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.stateHandle
import kz.dentalcrm.app.domain.AppointmentRepository
import kz.dentalcrm.app.screens.patients.mvi.PatientsViewEvent
import kz.dentalcrm.app.screens.patients.mvi.PatientsViewSideEffect
import kz.dentalcrm.app.screens.patients.mvi.PatientsViewState
import org.koin.core.component.inject

class PatientViewModel : BaseStateViewModel<PatientsViewEvent, PatientsViewState, PatientsViewSideEffect>() {

    private val appointmentRepository: AppointmentRepository by inject()

    private var isLastPage = false
    private var page = 1
    private val patientList = mutableListOf<kz.dentalcrm.app.data.network.response_model.PatientData>()
    private var searchJob: Job? = null

    override fun setInitialState() = PatientsViewState()

    init {
        loadNextPage()
    }

    override fun handleEvents(event: PatientsViewEvent) {
        when (event) {
            PatientsViewEvent.LoadNextPage -> loadNextPage()
            PatientsViewEvent.Refresh -> refresh()
            is PatientsViewEvent.RemovePatient -> removePatient(event.patientId)
            is PatientsViewEvent.OnSearchQueryChanged -> onSearchQueryChanged(event.query)
        }
    }

    private fun refresh() {
        page = 1
        patientList.clear()
        isLastPage = false
        setState { copy(patients = kotlinx.collections.immutable.persistentListOf(), error = null) }
        loadNextPage()
    }

    private fun removePatient(patientId: Int) {
        patientList.removeAll { it.id == patientId }
        setState { copy(patients = patientList.toPersistentList()) }
    }

    private fun onSearchQueryChanged(query: String) {
        setState { copy(searchQuery = query) }
        searchJob?.cancel()
        searchJob = launch {
            delay(500)
            refresh()
        }
    }

    private fun loadNextPage() {
        if (isLastPage) return
        setState { copy(isLoading = true) }
        launch(Dispatchers.Default) {
            val query = viewState.value.searchQuery
            val result = if (query.isEmpty()) {
                appointmentRepository.getPatients(page = page)
            } else {
                appointmentRepository.searchPatients(search = query, page = page)
            }
            result.stateHandle(
                onSuccess = { data ->
                    page++
                    isLastPage = (data?.data?.size ?: 0) < PAGE_SIZE
                    patientList.addAll(data?.data ?: emptyList())
                    setState { copy(isLoading = false, patients = patientList.toPersistentList()) }
                },
                onFailure = {
                    setState { copy(isLoading = false, error = "Не удалось обновить последние данные") }
                },
                onError = { _, _ ->
                    setState { copy(isLoading = false, error = "Не удалось обновить последние данные") }
                }
            )
        }
    }

    companion object {
        private const val PAGE_SIZE = 10
    }
}
